import React, { useState } from 'react';

const ProjectModal = ({ isOpen, onClose, onCreateProject, isLoading }) => {
  const [projectName, setProjectName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!projectName.trim()) {
      setError('Project name is required');
      return;
    }

    if (projectName.trim().length < 3) {
      setError('Project name must be at least 3 characters');
      return;
    }

    onCreateProject(projectName.trim());
  };

  const handleClose = () => {
    setProjectName('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="project-modal-overlay">
      <div className="project-modal-container">
        <h2 className="project-modal-title">Create New Project</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="project-form-group">
            <label className="project-form-label">Project Name:</label>
            <input
              type="text"
              value={projectName}
              onChange={(e) => {
                setProjectName(e.target.value);
                setError('');
              }}
              className="project-form-input"
              placeholder="Enter project name..."
              disabled={isLoading}
              maxLength={50}
              autoFocus
            />
            {error && (
              <span className="project-error-text">{error}</span>
            )}
          </div>
          
          <div className="project-modal-buttons">
            <button 
              type="button"
              onClick={handleClose}
              disabled={isLoading}
              className="project-cancel-btn"
            >
              Cancel
            </button>
            <button 
              type="submit" 
              disabled={isLoading || !projectName.trim()}
              className="project-create-btn"
            >
              {isLoading ? 'Creating...' : 'Create Project'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProjectModal;